"use strict";
'use strict';

const EMPTY_STYLES = Object.freeze({});
const EMPTY_SLOT_STYLES = Object.freeze(
  {}
);

exports.EMPTY_SLOT_STYLES = EMPTY_SLOT_STYLES;
exports.EMPTY_STYLES = EMPTY_STYLES;
